import JsonDiffViewer from '@/components/common/DiffViewer/JsonDiffViewer';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { PlannerConfigEntity } from '@/services/configurator/PlannerConfigTypes';
import { Dispatch, SetStateAction } from 'react';

function PlannerDiffDialog({
  showDiff,
  setShowDiff,
  setPrev,
  setCurrent,
  prev,
  current,
}: {
  showDiff: string;
  setShowDiff: Dispatch<SetStateAction<string>>;
  setPrev: Dispatch<SetStateAction<PlannerConfigEntity | null>>;
  setCurrent: Dispatch<SetStateAction<PlannerConfigEntity | null>>;
  prev: PlannerConfigEntity | null;
  current: PlannerConfigEntity | null;
}) {
  return (
    <Dialog
      open={!!showDiff}
      onOpenChange={() => {
        setShowDiff('');
        setPrev(null);
        setCurrent(null);
      }}
    >
      <DialogContent className='max-w-screen overflow-y-scroll'>
        <DialogHeader>
          <DialogTitle>Backup diff</DialogTitle>
        </DialogHeader>
        <div className='grid gap-4 px-1 py-4 pe-4 overflow-y-scroll max-h-[80vh] min-h-[80vh] items-center justify-center'>
          {showDiff && prev && current ? (
            <JsonDiffViewer previous={prev} current={current} />
          ) : (
            <div>Loading diff...</div>
          )}
        </div>
        <DialogFooter className='sm:justify-end'></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
export default PlannerDiffDialog;
